<template>
  <div id="cortonaSpace">
    <iframe name="previewIframe" :title="''" id="previewIframe" :src="iframeSrc" :style="iframeStyle"></iframe>
    <div id="loading">
      <v-progress-circular
        v-if="progress && progress < 100"
        :model-value="progress"
        :size="140"
        :width="8"
        color="primary"
      >
        {{ Math.round(progress) }}%
      </v-progress-circular>
      <div v-else class="middle">
        <div class="lds-hourglass"></div>
      </div>
    </div>
  </div>
</template>

<script>
import hexRgb from 'hex-rgb';
import { debounce } from 'debounce';
import IninIPC from '../../engine/IninIPC';
import IninINS from '../../engine/IninINS';

export default {
  name: 'CortonaLoader',
  props: {
    type: String,
    modelPath: String,
    modelValue: Object,
  },
  emits: ['update:modelValue', 'update', 'sheetSelected', 'changeVisibility', 'selectFirstRowOnVariantNavi'],
  data() {
    return {
      iframeSrc: '',
      xmlPath: this.modelPath,
      loaded: false,
      fromCache: false,
      progress: 0,
      ininInstance: null,
    };
  },
  watch: {
    modelPath: {
      immediate: true,
      handler(current, prev) {
        console.log('new resource url: ', current);
        this.iframeSrc = current;
      },
    },
  },
  computed: {
    iframeStyle() {
      return this.loaded ? '' : 'display: none';
    },
    inin: {
      get() {
        return this.ininInstance;
      },
      set(newInstance) {
        this.$ininCache[this.xmlPath] = newInstance;
        this.ininInstance = newInstance;
        this.$emit('update:modelValue', newInstance);
      },
    },
    InstanceType() {
      switch (this.type) {
        case 'CORTONA_IPC':
          return IninIPC;
        case 'CORTONA_WORK_INSTRUCTION':
          return IninINS;
      }
    },
  },
  methods: {
    getById(id) {
      return this.$window.document.getElementById(id);
    },
    resizeFrame: debounce(function () {
      if (true) return;
      let inin = this.inin;
      if (inin && inin.cortonaFrame) {
        let loading = this.getById('loading');
        let rect = loading.getBoundingClientRect();
        let brect = this.$window.document.body.getBoundingClientRect();
        let frame = inin.cortonaFrame;
        frame.style.top = rect.top - brect.top + 'px';
        frame.style.left = rect.left - brect.left + 'px';
        frame.style.width = rect.width + 'px';
        frame.style.height = rect.height + 'px';
      }
    }, 200),
    showFrame() {
      // this.$window.addEventListener('resize', this.resizeFrame);
      // this.resizeFrame();
      this.getById('loading').style.display = 'none';
      // this.getById('previewIframe').style.visibility = 'block';
      // this.inin.cortonaFrame.style.display = 'block';
      // if (!this.fromCache) this.inin.cortona.app.procedure.play();
      this.loaded = true;
    },

    createNewFrame() {
      this.iframeSrc = '/content/cortona/v1/iframe.html?m=' + this.xmlPath;
      let iframe = this.getById('previewIframe');
      iframe.onload = this.onFirstFrameLoad(iframe);
      /*
      let frames = this.getById('frames');
      let iframe = this.$window.document.createElement('iframe');
      iframe.src = '/content/cortona/v1/iframe.html?m=' + this.xmlPath;
      iframe.sandbox = 'allow-same-origin allow-scripts';
      iframe.style.overflow = 'hidden';
      iframe.style.border = 'none';
      iframe.style.position = 'absolute';
      iframe.style.zIndex = '-1000';
      iframe.style.display = 'none';
      iframe.style.borderRadius = '10px 10px 0px 0px';
      iframe.onload = this.onFirstFrameLoad(iframe);
      frames.appendChild(iframe);
      */
    },
    onFirstFrameLoad(iframe) {
      return () => {
        // console.log('onload iframe', iframe);
        let cortonaWindow = iframe.contentWindow;
        cortonaWindow.addEventListener('loadingProgress', event => {
          this.progress = event.detail;
        });
        if (cortonaWindow && cortonaWindow.Cortona3DSolo) {
          let canvas = cortonaWindow.document.getElementById('canvas');
          let colors = {
            accent: this.vuetifyColor('accent'),
          };
          this.inin = new this.InstanceType(cortonaWindow.Cortona3DSolo, canvas, this.xmlPath, this, colors);
          if (process.env.NODE_ENV === 'development') this.inin.logAllEvents();
          this.inin.cortonaFrame = iframe;
          // console.log('set', iframe, 'to', this.inin.cortonaFrame);
          const body = this.$window.document.body;
          const primaryRgb = getComputedStyle(body).getPropertyValue('--v-theme-primary').trim();
          const accentRgb = getComputedStyle(body).getPropertyValue('--v-theme-accent').trim();
          iframe.contentDocument.head.querySelector('#frameCss').prepend(
            `:root{
                          --v-primary-lighten4: rgba(${primaryRgb}, 0.2);
                          --v-accent-base: rgb(${accentRgb});
                          --v-theme-primary: ${primaryRgb};
                          --v-theme-accent: ${accentRgb};
                        }`
          );
          iframe.onload = null;
        }
      };
    },
    cloneCssVar(name) {
      return `${name}: ${getComputedStyle(this.$window.document.body).getPropertyValue(name)};`;
    },
    prepareNewOrCachedFrame() {
      let cortonaInstanceNotDestroyed =
        this.$ininCache[this.xmlPath]?.cortona === this.$ininCache[this.xmlPath]?.cortonaFrame?.contentWindow?.Cortona3DSolo;
      if (this.$ininCache[this.xmlPath] && cortonaInstanceNotDestroyed) {
        // console.log('loading frame from cache', this.xmlPath);
        this.inin = this.$ininCache[this.xmlPath];
        this.fromCache = true;
        this.inin.setExternal(this);
        if (this.inin.afterEngineLoad) this.inin.afterEngineLoad();
        this.inin.didFinishLoadDocument(true);
      } else {
        // console.log('preparing new frame', this.xmlPath);
        this.createNewFrame();
      }
    },
    vuetifyColor(name) {
      return hexRgb(this.$vuetify.theme.current.colors[name], { format: 'array' })
        .slice(0, 3)
        .map(c => c / 255);
    },
  },
  mounted() {
    this.prepareNewOrCachedFrame();
  },
  unmounted() {
    if (this.loaded) {
      // console.log('inin was loaded, caching');
      // this.inin.cortona.app.procedure.pause();
      this.inin.cortonaFrame.style.display = 'none';
      this.$window.removeEventListener('resize', this.resizeFrame);
      this.$window.removeEventListener('keydown', this.onKeyPress);
    } else {
      // console.log('inin was not loaded, destroying');
      this.inin.cortonaFrame.style.display = 'none';
      let frame = this.inin.cortonaFrame;
      if (frame) frame.remove();
      this.$ininCache[this.xmlPath] = undefined;
    }
  },
};
</script>

<style lang="scss" scoped>
#previewIframe {
  border: none;
  overflow: hidden;
  border-radius: 10px 10px 0px 0px;
  width: 100%;
  height: 100%;
}

#cortonaSpace {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: calc(100% - 10px) !important;
  // background-color: white;
  // border-radius: 10px 10px 0px 0px;
}
#loading {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // background-color: white;
  // border-radius: 10px 10px 0px 0px;
}

.middle {
  flex: 0 0 auto;
}

.lds-hourglass {
  content: ' ';
  display: block;
  border-radius: 50%;
  width: 0;
  height: 0;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  border: 50px solid rgb(var(--v-theme-primary));
  border-color: rgb(var(--v-theme-primary)) transparent rgb(var(--v-theme-primary)) transparent;
  animation: lds-hourglass 2.2s infinite;
}

@keyframes lds-hourglass {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  100% {
    transform: rotate(1800deg);
  }
}
</style>
